import React from "react";
import { Field } from "@atlaskit/form";
import Select from "@atlaskit/select";
export function MultiSelect(_a) {
    var options = _a.options, name = _a.name, label = _a.label, placeholder = _a.placeholder;
    return (React.createElement(Field, { name: name, label: label }, function (_a) {
        var fieldProps = _a.fieldProps;
        return (React.createElement(Select, { className: "multi-select", classNamePrefix: "react-select", options: options, isMulti: true, isSearchable: true, placeholder: placeholder, name: fieldProps.name, onChange: function (selectedOptions) {
                return fieldProps.onChange(selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map(function (option) { return option.value; }));
            } }));
    }));
}
